<template>
  <GenericWrapperChart :config="config" />
</template>

<script>
import { generateFileName } from '@/utils';

import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'InteractionsOverTime',
  components: {
    GenericWrapperChart,
  },
  data() {
    return {
      title: 'Interações ao longo do tempo',
    };
  },
  computed: {
    overrideChartOptions() {
      const filename = generateFileName(this.title);

      return {
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.interactionsOverTime.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? 'Soma das interações ao longo do tempo no período selecionado.' : '';
      const series = this.$store.state.charts.interactionsOverTime.data;
      const tooltipConfig = {
        addHeader: true,
        addFooter: false,
        addPercentVariation: false,
      };

      return {
        componentName: 'InteractionsOverTime',
        title,
        description,
        isLoading,
        hasError: this.$store.state.charts.interactionsOverTime.hasError,
        isEmpty: false,
        onError: this.getAllDataFromInteractionsOverTime,
        requestOnMounted: this.getAllDataFromInteractionsOverTime,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportInteractionTime Graph Open',
          trackNameOnDownload: 'BM ExportInteractionTime Graph Click',
        },
        chart: {
          type: 'AreaSpline',
          series,
          overrideChartOptions: this.overrideChartOptions,
          tooltipConfig,
          trackNameOnObserve: 'BM InteractionTime Graph View',
          trackNameOnLegendClick: 'BM InteractionTime LegendGraph Click',
        },
        insights: {
          data: this.$store.state.insights.interactionsOverTime.insights,
          trackNameToggle: 'BM InsightsEngagement UsefullQuestion View',
          trackNameFeedback: 'BM InsightsEngagement UsefullQuestion Update',
          trackNamePagination: 'BM InsightsEngagement UsefullQuestionPage Click',
        },
        periodSelector: {
          showPeriodSelector: true,
          onPeriodChange: this.getAllDataFromInteractionsOverTime,
          trackPeriod: 'BM PeriodEngagementTime Graph Click',
        },
      };
    },
  },
  methods: {
    async getAllDataFromInteractionsOverTime({ periodSelected } = {}) {
      await this.$store.dispatch('charts/fetchInteractionsOverTime', { datePortion: periodSelected });
      await this.$store.dispatch('insights/fetchInteractionsOverTimeInsights');
    },
  },
};
</script>
